import React from "react";
import Skeleton from "react-loading-skeleton";

const ProductPanelItemSkeleton: React.FC = () => {
  return (
    <li className="product-panel-item">
      <div className="product-panel-item__image">
        <Skeleton height={80} width={80} />
      </div>
      <div className="product-panel-item__content">
        <div className="product-panel-item__details">
          <Skeleton width="80%" />
          <Skeleton width="50%" style={{ marginTop: "0.5rem" }} />
        </div>
        <div className="product-panel-item__actions">
          <Skeleton height={32} />
        </div>
      </div>
    </li>
  );
};

export default ProductPanelItemSkeleton;
